var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import colors from '../../constants/js/colors.js';
import breakpoints from '../../constants/js/breakpoints.js';
import textSizes from '../../constants/js/text-sizes.js';
import text from '../../constants/js/text.js';
import { DATA_TEST } from '../../typings/data';
export const TEXT_WEIGHT = {
  normal: text.textWeightRegular,
  medium: text.textWeightMedium,
  bold: text.textWeightBold,
  black: text.textWeightBlack
};
const TEXT_SIZE = {
  '0': {
    mobile: 'fs24',
    tablet: 'fs32',
    desktop: 'fs48'
  },
  '1': {
    mobile: 'fs24',
    tablet: 'fs32',
    desktop: 'fs32'
  },
  '2': {
    mobile: 'fs18',
    tablet: 'fs24',
    desktop: 'fs32'
  },
  '3': {
    mobile: 'fs16',
    tablet: 'fs18',
    desktop: 'fs24'
  },
  '4': {
    mobile: 'fs16',
    tablet: 'fs18',
    desktop: 'fs18'
  },
  '5': {
    mobile: 'fs14',
    tablet: 'fs16',
    desktop: 'fs16'
  },
  '6': {
    mobile: 'fs12',
    tablet: 'fs14',
    desktop: 'fs14'
  },
  '7': {
    mobile: 'fs12',
    tablet: 'fs12',
    desktop: 'fs12'
  },
  '8': {
    mobile: 'fs10',
    tablet: 'fs10',
    desktop: 'fs10'
  }
};
const MEDIA = {
  desktop: `(min-width: ${breakpoints.xl})`,
  tablet: `(min-width: ${breakpoints.md})`
};

const getSizeStyles = (level, deviceType) => {
  const textSize = textSizes[TEXT_SIZE[level][deviceType]];
  return css(["font-size:", ";line-height:", ";"], textSize.fontSize, textSize.lineHeight);
};

const StyledText = styled.div.withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => !['color'].includes(prop) && !['size'].includes(prop) && !['transform'].includes(prop) && defaultValidatorFn(prop)
}).withConfig({
  componentId: "TextResponsive__sc-uiydf7-0"
})(["color:", ";text-align:", ";font-weight:", ";", " ", " ", " ", ""], ({
  color
}) => color && colors[color], ({
  align
}) => align, ({
  weight
}) => weight && TEXT_WEIGHT[weight], ({
  isNowrap
}) => isNowrap && css(["white-space:nowrap;"]), ({
  transform
}) => transform && ['lowercase', 'uppercase', 'capitalize', 'no-transform'].includes(transform) && css(["text-transform:", ";"], transform), ({
  transform
}) => transform === 'ellipsis' && css(["word-break:break-word;overflow:hidden;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;"]), ({
  size
}) => size && css(["", " @media ", "{", "}@media ", "{", "}"], getSizeStyles(size, 'mobile'), MEDIA.tablet, getSizeStyles(size, 'tablet'), MEDIA.desktop, getSizeStyles(size, 'desktop')));
const defaultProps = {
  tagName: 'div',
  align: 'left',
  isNowrap: false,
  weight: 'normal',
  color: 'majorBlack',
  [DATA_TEST]: 'text'
};
export const TextResponsive = _a => {
  var {
    tagName = defaultProps.tagName,
    align = defaultProps.align,
    isNowrap = defaultProps.isNowrap,
    weight = defaultProps.weight,
    color = defaultProps.color,
    dataTest = defaultProps.dataTest
  } = _a,
      otherProps = __rest(_a, ["tagName", "align", "isNowrap", "weight", "color", "dataTest"]);

  return React.createElement(StyledText, Object.assign({
    as: tagName,
    align: align,
    isNowrap: isNowrap,
    weight: weight,
    color: color,
    "data-test": dataTest
  }, otherProps));
};